"use client"
import { useEffect, useState } from "react";

const Visite = () => {
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const [iframeSrc, setIframeSrc] = useState('');


  useEffect(() => {
    const uniqueQuery = `?t=${Date.now()}`;
    setIframeSrc(`/panorama/index.html${uniqueQuery}`);
  }, []);
  return (
    <div>
       {/* iFrame Container for 360° View */}
      <div
        style={{
          width: "100%",
          height: "500px",
          overflow: "hidden",
          position: "relative",
        }}
      >
        <iframe
          src={iframeSrc} // Ensure the extracted files are in /public/panorama/
          width="100%"
          height="100%"
          style={{ border: "none", display: iframeLoaded ? "block" : "none" }}
          onLoad={() => setIframeLoaded(true)}
          key={iframeSrc}
        ></iframe>
        {/* Optional Loading Indicator */}
        {!iframeLoaded && (
          <div className="flex justify-center items-center h-full">
            <p className="text-gray-500">Chargement de la visite virtuelle...</p>
          </div>
        )}
      </div>
    </div>
  )
}

export default Visite


